@if (showComponent()) {
    <div class="container-fluid well">
        <h5>{{title}}</h5>
        <div class="row">
            <div class="col-xs-8">
                <label
                    class="control-label"
                    for="adviceName">
                    Advice received
                </label>
                <div class="input-group">
                    <span class="input-group-addon">
                        <i class="nlrp-icon nlrp-icon-edit"></i>
                    </span>
                    <input
                        type="text"
                        class="form-control"
                        name="adviceName"
                        id="adviceName"
                        placeholder="Enter Advice Receive Name"
                        title="Enter the name of the person who provided advice"
                        [maxlength]="50"
                        [disabled]="isDisabled()"
                        [(ngModel)]="getModel().adviceName"
                        #adviceName="ngModel" />
                </div>
            </div>
            <div class="col-xs-4">
                <label
                    class="control-label"
                    for="adviceDate">
                    Advice date
                </label>
                <input
                    type="date"
                    id="adviceDate"
                    name="adviceDate"
                    placeholder="Enter Advice Date"
                    title="Enter the date land registry advice was sought"
                    class="form-control"
                    [max]="maxDateIsoString"
                    [nlrMaxDate]="maxDateIsoString"
                    [disabled]="isDisabled()"
                    (change)="onChangeAdviceDate()"
                    (keydown)="preventKeydownEvent($event)"
                    [(ngModel)]="adviceDateIsoString"
                    #adviceDate="ngModel" />
                <input
                    id="adviceDateShadow"
                    name="adviceDateShadow"
                    title="Enter the date land registry advice was sought"
                    [ngModel]="adviceDateDisplayString()"
                    placeholder="Enter Advice Date"
                    readonly
                    type="text" />
                @if (adviceDate | formFieldHasError) {
                    <div>
                        @if (adviceDate.errors?.nlrMaxDate) {
                            <div class="help-block">
                                <span>Error!</span>
                                <span>Advice date cannot be in the future.</span>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
        <div class="row">
            <div class="col-xs-8">
                <label
                    class="control-label"
                    for="adviceComment">
                    Advice received comment
                </label>
                <div class="input-group textarea-addon-fix">
                    <span class="input-group-addon corner">
                        <i class="nlrp-icon nlrp-icon-edit corner-icon"></i>
                    </span>
                    <textarea
                        class="form-control"
                        name="adviceComment"
                        id="adviceComment"
                        placeholder="Enter Advice Comment"
                        title="Enter the land registry advice received"
                        rows="4"
                        cols="50"
                        [maxlength]="255"
                        [disabled]="isDisabled()"
                        [(ngModel)]="getModel().adviceComment"
                        #adviceComment="ngModel">
                    </textarea>
                </div>
            </div>
        </div>
    </div>
}
